export const PhoneIcon = ({ color = '#0000DB', ...props }) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={'19'}
    height={'19'}
    viewBox={'0 0 19 19'}
    fill={'none'}
    {...props}
  >
    <title>phone icon</title>
    <path
      d={'M17.8917 19C15.6926 19 13.5199 18.5206 11.3736 17.5618C9.22732 16.603 7.27454 15.244 5.51528 13.4847C3.75602 11.7255 2.39699 9.77269 1.43819 7.62639C0.479398 5.48009 0 3.30741 0 1.10833C0 0.791667 0.105556 0.527778 0.316667 0.316667C0.527778 0.105556 0.791667 0 1.10833 0H5.38333C5.62963 0 5.84954 0.0835648 6.04306 0.250694C6.23657 0.417824 6.35093 0.615741 6.38611 0.844444L7.07222 4.53889C7.10741 4.82037 7.09861 5.05787 7.04583 5.25139C6.99306 5.44491 6.8963 5.61204 6.75556 5.75278L4.19583 8.33889C4.54769 8.98981 4.96551 9.61875 5.44931 10.2257C5.9331 10.8326 6.46528 11.4176 7.04583 11.9806C7.5912 12.5259 8.16296 13.0317 8.76111 13.4979C9.35926 13.9641 9.99259 14.3907 10.6611 14.7778L13.1417 12.2972C13.3 12.1389 13.5067 12.0201 13.7618 11.941C14.0169 11.8618 14.2676 11.8398 14.5139 11.875L18.1556 12.6139C18.4019 12.6843 18.6042 12.8118 18.7625 12.9965C18.9208 13.1813 19 13.388 19 13.6167V17.8917C19 18.2083 18.8944 18.4722 18.6833 18.6833C18.4722 18.8944 18.2083 19 17.8917 19Z'}
      fill={color}
    />
  </svg>
);
